<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="MaxiflameMaxifresh_1d02_P50"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import MaxiflameMaxifresh_1d02_P50 from '@/device-products/MaxiflameMaxifresh_1d02_P50.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
    ],
    simulationDevices: [
      { id: 0, component: MaxiflameMaxifresh_1d02_P50, deviceLabel: 'Codierung 0: FREQ', props: { leiterplattenCodierung: 0 } },
    ],
  }),
};
</script>

<style>

</style>
